import { render, staticRenderFns } from "./kefuList.vue?vue&type=template&id=83923030&scoped=true"
import script from "./kefuList.vue?vue&type=script&lang=js"
export * from "./kefuList.vue?vue&type=script&lang=js"
import style0 from "./kefuList.vue?vue&type=style&index=0&id=83923030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83923030",
  null
  
)

export default component.exports